




















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import {mixins} from "vue-class-component";
import moment from "moment/moment";
import {Component, Watch} from "vue-property-decorator";
import {Site} from "@/shared/Site";
import MyMixin from "@/mixins/datemixin";
import MobileMixin from "@/mixins/mobileMixin";
import TicketMixin from "@/mixins/ticketsMixin";
import ExpandableDateChooser from "@/components/expansion/expandableDateChooser.vue";
import ExpandableListeSites from "@/components/expansion/expandableListeSites.vue";
import ExpandableCriteres from "@/components/expansion/expandableCriteres.vue";
import DateType from "@/shared/DateType";
import TicketsUtils from "../utils/TicketsUtils";
import PdfViewer from "@/components/pdf-viewer.vue";
import ErrorMixin from "@/mixins/errorMixins";
import PdfReport from "@/shared/pdfReport";
import VueJsonToCsv from "vue-json-to-csv";
import TicketAudit from "@/ui-component/TicketAudit.vue";
import _ from "lodash";

@Component({
  components: {
    ExpandableDateChooser,
    ExpandableListeSites,
    ExpandableCriteres,
    PdfViewer,
    VueJsonToCsv,
    TicketAudit,
  },
})
export default class Tickets extends mixins(
    MyMixin,
    MobileMixin,
    TicketMixin,
    ErrorMixin
) {
  public dateType: DateType = new DateType();
  public selectedSites: Site[] = [];
  public tickets: any = [];
  public ticketsPaginated: any = [];
  public message: string = "";
  public dateFiscale = 0;
  public showRep = false;
  /**
   * switch entre pdf et détail pour les profils avec droit rapport anomalies
   */
  public choosePdf = 0;
  public ticketAuditGetted = false;
  public mesFiltres = new Array();
  public loadData: boolean = false;
  public loadAllTickets: boolean = false;
  public loadTicket: boolean = false;
  public headers: any = [];
  public menuF = false;
  public menuD = false;
  public showPdf: boolean = false;
  public src: string = "";
  public updatedSearchCrit: boolean = false;
  public ticketAudit: any = {};
  public selectedId: string = "";

  public filter: { [k: string]: any } = {};

  public show: any = {
    recu: false,
    ticket: true,
    total: false,
  };

  public pdfReport: PdfReport = new PdfReport();

  public allTickets: any = []; // Stockage de tous les tickets pour CSV

  // Pagination côté client
  public currentPage: number = 1;
  public totalTickets: number = 0;
  public serverItemsPerPage: number = 50;
  public availablePageSizes: number[] = [25, 50, 100];
  public tempPageInput: string = "";
  public targetPage: number = 1;
  public sortBy: string[] = [];
  public sortDesc: boolean[] = [];

  public async mounted() {
    await TicketsUtils.getFilters().then((data: any) => {
      // Si on est sur le client TOTAL, on ne doit pas afficher certains filtres
      if (this.client === "TOTAL") {
        this.mesFiltres = data.filter(
            (item: any) => item.cle !== "NB_ARTICLES"
        );
      } else {
        this.mesFiltres = data;
      }
    });

    interface ChoixObjet {
      cle: string;
      choix: string[];
    }

    if (this.client === "TOTAL") {
      const clesAExclure = [
        "LIBELLE_REGLEMENT",
        "MONTANT_MAX_REGLEMENT",
        "MONTANT_MIN_REGLEMENT",
      ];

      this.mesFiltres = this.mesFiltres.filter(
        (item: ChoixObjet) => !clesAExclure.includes(item.cle)
      );

      const cible = this.mesFiltres.find(
        (item: ChoixObjet) => item.cle === "FAMILLE_REGLEMENT"
      );

      if (cible) {
        cible.choix = cible.choix.filter(
          (val: string) => val !== "ANCV" && val !== "ESPECES"
        );
      }
    }

    this.filter["RESTAURANT_ID"] = [];
    this.filter["LIB_SITE"] = [];

    this.mesFiltres.forEach((filtre: any) => {
      if (["RESTAURANT_ID", "LIB_SITE"].includes(filtre.cle)) {
        filtre.format = "CHOIX_MULTIPLE";
      }
      if (filtre.mandatory || filtre.cle === "RESTAURANT_ID") {
        switch (filtre.cle) {
          case "DOCUMENT":
            this.filter["DOCUMENT"] = "TICKET";
            break;
          case "DATE_FIN":
          case "DATE_DEBUT":
            this.filter[filtre.cle] = moment().format("YYYY-MM-DD");
            break;
          case "RESTAURANT_ID":
            if (this.client !== "TOTAL") {
              this.filter["RESTAURANT_ID"] = [this.sites[0].restaurantId];
            }
            break;
          case "LIB_SITE":
            if (this.client !== "TOTAL") {
              this.filter["LIB_SITE"] = [this.sites[0].libelle];
            }
            break;
          case "TRAINING_MODE":
            this.filter["TRAINING_MODE"] = false;
            break;
          default:
            switch (filtre.format) {
              case "MONETAIRE":
              case "NUMBER":
                this.filter[filtre.cle] = 0;
                break;
              case "BOOLEAN":
                this.filter[filtre.cle] = true;
                break;
              default:
                this.filter[filtre.cle] = "";
                break;
            }
            break;
        }
      }
    });
    if (this.client !== "TOTAL") {
      this.addSite(this.sites[0]);
    }

    this.updateHeader();
    // Si selectedSites n'a pas de valeurs, on renvoie une erreur pour informer l'utilisateur
    // Car c'est la requête getSites qui n'a pas fini de charger
    if (this.selectedSites.length === 0 && this.client !== "TOTAL") {
      this.setErrorFromTxt(this.$t("NoSitesSelected").toString());
    }
  }

  public paginateTickets(): void {
    this.sortAndPaginate();
  }

  public goToTargetPage(): void {
    const maxPage = Math.ceil(this.totalTickets / this.serverItemsPerPage);
    if (this.targetPage >= 1 && this.targetPage <= maxPage) {
      this.currentPage = this.targetPage;
    }
  }

  public changeSortBy(sortBy: string[]): void {
    this.sortBy = sortBy;
    this.sortAndPaginate();
  }

  public changeSortDesc(sortDesc: boolean[]): void {
    this.sortDesc = sortDesc;
    this.sortAndPaginate();
  }

  @Watch("currentPage")
  public onCurrentPageChanged(newPage: number): void {
    this.tempPageInput = newPage.toString();
    if (this.client === "TOTAL") {
      this.paginateTickets();
    }
  }

  public sortAndPaginate(): void {
    this.filterSortAndPaginate();
  }


  // Watcher pour déclencher le filtrage quand les inputs changent (côté total)
  @Watch("date")
  @Watch("site")
  @Watch("caisse")
  @Watch("vendeur")
  @Watch("vendeurRemunere")
  @Watch("ticket")
  @Watch("total")
  @Watch("localisation")
  @Watch("typeTransaction")
  @Watch("codeImplant")
  @Watch("TTC")
  @Watch("HT")
  @Watch("TVA")
  @Watch("tauxTVA")
  @Watch("reglement")
  @Watch("article")
  @Watch("qte")
  @Watch("prixUnitaire")
  @Watch("EAN")
  @Watch("PAN")
  @Watch("carte")
  @Watch("currency")
  public onFilterChange(): void {
    this.currentPage = 1; // Retour à la page 1 lors du filtrage
    this.filterSortAndPaginate();
  }

  public filterSortAndPaginate(): void {
    if (!this.tickets || this.tickets.length === 0) {
      this.ticketsPaginated = [];
      this.totalTickets = 0;
      return;
    }

    // Filtrage avec les vérifications
    let filteredTickets = this.tickets.filter((ticket: any) => {
      const optRef = ticket.optionalReference || {};

      return (
          (!this.date || this.formatDateTicketHour(ticket.horodatage).toLowerCase().includes(this.date.toLowerCase())) &&
          (!this.site || (ticket.libSite && ticket.libSite.toLowerCase().includes(this.site.toLowerCase()))) &&
          (!this.caisse || (optRef.LIB_CAISSE && optRef.LIB_CAISSE.toLowerCase().includes(this.caisse.toLowerCase()))) &&
          (!this.vendeur || (optRef.LIB_VENDEUR && optRef.LIB_VENDEUR.toLowerCase().includes(this.vendeur.toLowerCase()))) &&
          (!this.vendeurRemunere || (optRef.COMPLEMENTS && optRef.COMPLEMENTS.toLowerCase().includes(this.vendeurRemunere.toLowerCase()))) &&
          (!this.ticket || (ticket.numDoc && ticket.numDoc.toLowerCase().includes(this.ticket.toLowerCase()))) &&
          (!this.total || (optRef.MONTANT && optRef.MONTANT.toString().includes(this.total))) &&
          (!this.localisation || (optRef.LOCALISATION && optRef.LOCALISATION.toLowerCase().includes(this.localisation.toLowerCase()))) &&
          (!this.typeTransaction || (optRef.TYPE_TRANSACTION && optRef.TYPE_TRANSACTION.toLowerCase().includes(this.typeTransaction.toLowerCase()))) &&
          (!this.codeImplant || (optRef.CODE_IMPLANT && optRef.CODE_IMPLANT.toLowerCase().includes(this.codeImplant.toLowerCase()))) &&
          (!this.TTC || (optRef.MONTANT_TOTAL && optRef.MONTANT_TOTAL.toString().includes(this.TTC))) &&
          (!this.HT || (optRef.HT && optRef.HT.toString().includes(this.HT))) &&
          (!this.TVA || (optRef.MONTANT_TVA && optRef.MONTANT_TVA.toString().includes(this.TVA))) &&
          (!this.tauxTVA || (optRef.TAUX_TVA && optRef.TAUX_TVA.toString().includes(this.tauxTVA))) &&
          (!this.reglement || (optRef.REGLEMENT && optRef.REGLEMENT.toLowerCase().includes(this.reglement.toLowerCase()))) &&
          (!this.article || (optRef.LIBELLE_ARTICLE && optRef.LIBELLE_ARTICLE.toLowerCase().includes(this.article.toLowerCase()))) &&
          (!this.qte || (optRef.NB_ARTICLES && optRef.NB_ARTICLES.toString().includes(this.qte))) &&
          (!this.prixUnitaire || (optRef.PUTTC && optRef.PUTTC.toString().includes(this.prixUnitaire))) &&
          (!this.EAN || (optRef.CODE_EAN && optRef.CODE_EAN.toLowerCase().includes(this.EAN.toLowerCase()))) &&
          (!this.PAN || (optRef.PAN && optRef.PAN.toLowerCase().includes(this.PAN.toLowerCase()))) &&
          (!this.carte || (optRef.FAMILLE_REGLEMENT && String(optRef.FAMILLE_REGLEMENT).toLowerCase().includes(this.carte.toLowerCase()))) &&
          (!this.currency || (optRef.CURRENCY && optRef.CURRENCY.toLowerCase().includes(this.currency.toLowerCase())))
      );
    });

    // On trie
    if (this.sortBy.length > 0) {
      const sortField = this.sortBy[0];
      const isDesc = this.sortDesc[0] || false;

      filteredTickets = _.orderBy(filteredTickets, [sortField], [isDesc ? "desc" : "asc"]);
    }

    this.totalTickets = filteredTickets.length;

    // puis on pagine le tout
    const startIndex = (this.currentPage - 1) * this.serverItemsPerPage;
    const endIndex = startIndex + this.serverItemsPerPage;

    this.ticketsPaginated = filteredTickets.slice(startIndex, endIndex);
  }

  /**
   * Méthode pour remettre à la page 1 et chercher
   */
  public resetToFirstPageAndSearch(): void {
    this.currentPage = 1;
    this.updatedSearchCrit = true;
    this.message = this.$t("Update").toString();
    this.tickets = [];

    // Réactiver et lancer la recherche
    this.$nextTick(() => {
      this.getTicketsNormal();
    });
  }

  /**
   * Méthode de récupération des tickets avec pagination serveur
   */
  public getTickets(): void {
    console.log("Manual search triggered");

    this.resetToFirstPageAndSearch();
  }

  /**
   * methode permettant de faire disparaitre le dialogue contenant le rapport
   */
  public hide(target: any) {
    this.showRep = false;
  }

  /*
   * methode permettant de verifier si l'on doit ou pas afficher une div
   * sur la liste de ticket permettant de rafraichir celle ci
   */
  public showTicketsLoad(forceFalse?: boolean) {
    if (forceFalse) {
      this.updatedSearchCrit = false;
      return false;
    } else {
      if (this.tickets.length === 0) {
        return true;
      } else {
        if (this.updatedSearchCrit) {
          return true;
        }
      }
      return false;
    }
  }

  public closeLoad(evt: Event) {
    this.updatedSearchCrit = false;
    this.showTicketsLoad(true);
    evt.stopPropagation();
  }

  public updateDate(date: DateType) {
    // console.log("updateDate", date);
    this.dateType = date;
    this.filter.DATE_DEBUT = moment(this.dateType.dateDebut).format(
      "YYYY-MM-DD"
    );
    this.filter.DATE_FIN = moment(this.dateType.dateFin).format("YYYY-MM-DD");

    this.updatedSearchCrit = true;
    this.message = this.$t("Update").toString();
  }

  public getMyClass(item: any) {
    if (item && item.id === this.selectedId) {
      // console.log(item);
      return "ticketSelected";
    } else {
      return "item";
    }
  }

  public addSite(site: Site) {
    // console.log("add site ticket", site);
    if (this.client === "TOTAL") {
      if (this.selectedSites.includes(site)) {
        this.selectedSites.splice(this.selectedSites.indexOf(site), 1);
        if (this.filter.RESTAURANT_ID.includes(site.restaurantId)) {
          this.filter.RESTAURANT_ID.splice(
            this.filter.RESTAURANT_ID.indexOf(site.restaurantId),
            1
          );
        }
        if (this.filter.LIB_SITE.includes(site.libelle)) {
          this.filter.LIB_SITE.splice(
            this.filter.LIB_SITE.indexOf(site.libelle),
            1
          );
        }
      } else {
        this.selectedSites.push(site);
        if (!this.filter.RESTAURANT_ID.includes(site.restaurantId)) {
          this.filter.RESTAURANT_ID.push(site.restaurantId);
        }
        if (!this.filter.LIB_SITE.includes(site.libelle)) {
          this.filter.LIB_SITE.push(site.libelle);
        }
      }
    } else {
      this.selectedSites = [site];
      this.filter.RESTAURANT_ID = [site.restaurantId];
      this.filter.LIB_SITE = [site.libelle];
    }
    this.updatedSearchCrit = true;

    // console.log(this.filter);
    this.message = this.$t("Update").toString();
  }

  public removeAllSites() {
    this.selectedSites = [];
    this.filter.RESTAURANT_ID = [];
    this.filter.LIB_SITE = [];

    this.message = this.$t("Update").toString();
  }

  @Watch("filter", { immediate: true })
  public onPropertyChangedBis(value: any, oldValue: any) {
    // console.log("filter updated");
    if (oldValue !== undefined) {
      this.updatedSearchCrit = true;
      this.message = this.$t("Update").toString();
    }
  }

  /**
   * mide a jour d'un parametre reaffichage du boutton rechercher
   */
  public updateParam() {
    // console.log(this.filter);
    this.updatedSearchCrit = true;
    this.message = this.$t("Update").toString();
  }

  /**
   * methode de mise a jour du header du tableau en fonction
   * du type de ticket cherché
   */
  public updateHeader() {
    if (this.client === "TOTAL") {
      this.headers = this.getTotalTicketHeaders();
    } else {
      this.headers = this.generateHeader();
    }
  }

  /**
   * Méthode pour changer de page
   */
  public changePage(page: number): void {
    console.log("Manual page change to:", page);

    if (page !== this.currentPage && page > 0) {
      this.currentPage = page;
      this.paginateTickets();
    }
  }

  /**
   * Méthode pour changer la taille de page
   */
  public changePageSize(size: number): void {
    console.log("Page size change to:", size);

    if (size !== this.serverItemsPerPage) {
      this.serverItemsPerPage = size;
      this.currentPage = 1;
      this.paginateTickets();
    }
  }

  /**
   * methode de récuperation des tickets sur le serveur
   */
  public getTicketsNormal() {
    this.updatedSearchCrit = false;
    this.message = "";
    this.loadData = true;
    const filterWithFormat: any = {};

    for (const cleFiltre of Object.keys(this.filter)) {
      filterWithFormat[cleFiltre] = {
        value: this.filter[cleFiltre],
      };

      const filtreFound = this.mesFiltres.find((filtre: any) => filtre.cle === cleFiltre);
      if (filtreFound) {
        filterWithFormat[cleFiltre]["format"] = filtreFound.format;
      } else {
        console.warn(`Aucun format trouvé pour la clé: ${cleFiltre}`);
      }
    }

    if (
      this.filter.RESTAURANT_ID.length === 0 ||
      this.filter.LIB_SITE.length === 0
    ) {
      this.sites.forEach((site: any) => {
        this.filter.LIB_SITE.push(site.libelle);
        this.filter.RESTAURANT_ID.push(site.restaurantId);
      });
    }

    if (this.sites.length === 1) {
      this.selectedSites = [this.sites[0]];
    }

    TicketsUtils.getDocuments(filterWithFormat, this.selectedSites)
      .then(
        (liste: any) => {
          this.tickets = liste;
          this.tickets = _.uniqBy(liste, "id");
          this.tickets = _.orderBy(this.tickets, "horodatage");
          if (this.client === "TOTAL") {
            this.tickets = this.translateTypeTransactionTickets(this.tickets);
            // Initialiser le tri par défaut pour le data-table
            this.sortBy = ["horodatage"];
            this.sortDesc = [true];
            this.paginateTickets();
          }
          this.updateHeader();
          if (this.tickets.length === 0) {
            this.message = this.$t("NoTicketToCrit").toString();
          }
          this.loadData = false;
        },
        (err: any) => {
          this.loadData = false;
          console.log(err);
          this.setError(err);
        }
      )
      .catch((error: any) => {
        this.loadData = false;
        console.log(error);
        this.setError(error);
      });
  }

  /**
   * recuperation de tous les tickets correspondant à la recherche dans un meme pdf
   */
  public getAllTicketPdf() {
    this.loadData = true;
    TicketsUtils.getPdfTickets(this.filter)
      .then(
        (res) => {
          if (res.status === 409) {
            this.setError(res.message);
            // this.close();
            this.loadData = false;
            return;
          }
          const blob = new Blob([res.data], {
            type: res.headers["content-type"],
          });
          const bloburl = (window.URL || window || {}).createObjectURL(blob);
          this.pdfReport.src = bloburl;
          const titre = this.getCsvTicketsTitle();
          this.pdfReport.titre = titre;
          // console.log(titre);
          const fileLink = document.createElement("a");
          fileLink.href = bloburl;
          fileLink.setAttribute("download", titre);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.$store.dispatch("login/setLoading", false);
          this.loadData = false;
        },
        (err: any) => {
          let shortErr = err.toString().substring(7);
          shortErr = JSON.parse(shortErr).message;
          const errMess = JSON.parse(shortErr);
          this.loadData = false;
          this.setError(errMess);
          // this.close();
        }
      )
      .catch((error: any) => {
        this.setError(error);
        this.loadData = false;
      });
  }

  /*
   * méthode de récuperation d'un ticket
   */
  public getTicket(ticket: any) {
    this.loadTicket = true;
    this.selectedId = ticket.id;
    this.ticketAuditGetted = false;
    TicketsUtils.getDocument(ticket)
      .then(
        (ticketpdf: any) => {
          this.showTicket(ticketpdf, ticket.id);
          if (
            (this.client === "BK" ||
              this.me.droits.indexOf("RAPPORTS_ANOMALIES") !== -1) &&
            !this.global &&
            this.filter.DOCUMENT !== "RECU_REGLEMENT_EMPLOYE"
          ) {
            TicketsUtils.getTicketAudit(ticket).then((response: any) => {
              this.ticketAuditGetted = true;
              this.ticketAudit = JSON.parse(response.source);
            });
          }
        },
        (err: any) => {
          this.loadTicket = false;
          this.setError(err);
        }
      )
      .catch((error: any) => {
        this.loadTicket = false;
        console.log(error);
        this.setError(error);
      });
  }

  public getCsvTicketsTitle() {
    const start = moment(this.dateType.dateDebut).format("DD-MM-YYYY");
    const end = moment(this.dateType.dateFin).format("DD-MM-YYYY");
    let titre = "";
    if (this.selectedSites.length === 1) {
      titre =
        this.$t("csvTicketTitle") +
        `-${this.selectedSites[0].libelle}-${start}-${end}`;
    } else {
      titre =
        this.$t("csvTicketsTitle") +
        `-${this.$t("multiSites").toString()}-${start}-${end}`;
    }
    console.log("titre du CSV: ", titre);
    return titre;
  }

  /**
   * affichage du pdf du ticket selectionné
   */
  private showTicket(ticketpdf: any, ticketId: string) {
    this.loadTicket = false;
    const blob = new Blob([ticketpdf.data], {
      type: ticketpdf.headers["content-type"],
    });
    const bloburl = (window.URL || window || {}).createObjectURL(blob);
    this.src = bloburl;
    this.pdfReport.src = bloburl;
    (this.pdfReport.titre = ticketId + ".pdf"), (this.showPdf = true);
    if (this.isIframe()) {
      this.showRep = true;
    }
  }

  private translateTypeTransactionTickets(listeTickets: any) {
    listeTickets.forEach((ticket: any) => {
      if (
        ticket.optionalReference.TYPE_TRANSACTION.includes("P") ||
        ticket.optionalReference.TYPE_TRANSACTION.includes("V")
      ) {
        ticket.optionalReference.TYPE_TRANSACTION =
          ticket.optionalReference.TYPE_TRANSACTION.replaceAll(
            "P",
            "W"
          ).replaceAll("V", "U");
      }

      const ht = parseFloat(
        ticket.optionalReference.HT.toString().replace(",", ".")
      );
      const tva = parseFloat(
        ticket.optionalReference.MONTANT_TVA.toString().replace(",", ".")
      );
      const nbArticles = Number(ticket.optionalReference.NB_ARTICLES);

      const montantTotal = Math.round((ht + tva) * 100) / 100;

      ticket.optionalReference.MONTANT_TOTAL =
        Math.round((ht + tva) * 100) / 100;
      ticket.optionalReference.PUTTC =
        Math.round((montantTotal / nbArticles) * 100) / 100;
      ticket.optionalReference.HT = Math.round(ht * 100) / 100;
      ticket.optionalReference.MONTANT_TVA = Math.round(tva * 100) / 100;
    });

    return listeTickets;
  }

  get global(): boolean {
    return this.$store.getters["getGlobal"];
  }

  get sites(): Site[] {
    return this.$store.getters["login/sites"];
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }

  get me(): any {
    return this.$store.getters["login/user"];
  }

  get isSearchButtonDisable(): boolean {
    return this.selectedSites.length === 0 && this.sites.length > 1;
  }
}
